<app-chip-autocomplete
    [class.compact-layout]="compactLayout"
    [formControl]="control"
    [Disabled]="disabled"
    [required]="required"
    [Placeholder]="placeholder"
    [Options]="_options$ | async"
    [MapFn]="MapFn"
    [CompareFn]="CompareFn"
    (UnknownOptionSubmitted)="addCategory($event)"
    [OptionTemplate]="optionTemplate"
    [initialPatchDefaultValue]="true">
</app-chip-autocomplete>

<ng-template #optionTemplate let-Option>
    <div class="div-chip">
        {{ MapFn(Option) }}
        <button mat-icon-button (click)="deleteCategory(Option, $event)">
            <fa-icon icon="trash" class="fa-icon-chip"></fa-icon>
        </button>
    </div>
</ng-template>
